export default __webpack_public_path__ + "static/bg-doctor--mobile-a406c32eaabd65816e54e850cf3fe7ad.webp";